<template>
  <div class="video-list container">
    <h1 class="purple">
      <svg xmlns="http://www.w3.org/2000/svg" width="39" height="37">
        <!-- eslint-disable-next-line max-len -->
        <path
          class="st0"
          d="M30.6 36.9c-0.3 0-0.6-0.1-0.9-0.3l-9.5-5.8c-0.4-0.3-1.3-0.3-1.7 0l-9.5 5.8c-0.7 0.4-1.4 0.4-1.8-0.1 -0.2-0.2-0.4-0.6-0.2-1.3L9.6 24.4c0.1-0.5-0.1-1.3-0.5-1.6l-8.4-7.3c-0.7-0.6-0.6-1.2-0.6-1.5 0.1-0.2 0.4-0.8 1.3-0.9l11.1-0.9c0.5 0 1.2-0.5 1.4-1l4.3-10.2C18.5 0.1 19.1 0 19.4 0s0.8 0.1 1.2 1l4.3 10.2c0.2 0.5 0.9 1 1.4 1l11.1 0.9c1 0.1 1.2 0.6 1.3 0.9 0.1 0.2 0.2 0.8-0.6 1.5l-8.4 7.3c-0.4 0.3-0.6 1.1-0.5 1.6l2.5 10.8c0.2 0.7 0 1.1-0.2 1.3C31.3 36.8 31 36.9 30.6 36.9zM1.8 14.6l8.2 7.1c0.8 0.7 1.2 2 1 3.1L8.5 35.3l9.3-5.6c0.9-0.5 2.3-0.5 3.2 0l9.3 5.6 -2.5-10.6c-0.2-1 0.2-2.4 1-3.1l8.2-7.1 -10.8-0.9c-1-0.1-2.2-0.9-2.6-1.9l-4.2-10 -4.2 10c-0.4 1-1.5 1.8-2.6 1.9L1.8 14.6z"
        />
      </svg>
      {{ heading }}
    </h1>

    <videos :videos="videosToView"></videos>
  </div>
</template>

<script>
import Videos from "@/components/Videos.vue";

export default {
  name: `VideoList`,

  components: {
    Videos,
  },
  computed: {
    videoList() {
      return this.$store.state.videos;
    },
    myvideos() {
      const vidArray = this.$store.state.user.myVideos;

      const arr = this.videoList.filter(v => {
        if (vidArray.includes(`${v.id}`)) {
          return true;
        }
        return false;
      });
      return arr;
    },

    videosToView() {
      if (this.$route.params.sort === `new`) {
        const newvideos = this.$store.getters.newVideos;
        return newvideos.slice(0, 30);
      }
      return this.myvideos;
    },

    heading() {
      if (this.$route.params.sort === `new`) {
        return `שיעורים חדשים`;
      }
      return `מועדפים / רשימת צפייה`;
    },

    isLoggedIn() {
      return this.$store.state.user.isLoggedIn;
    },
  },
  // created() {
  //   if (this.isLoggedIn === 0) {
  //     this.$router.push(`/profile`);
  //   }
  // },
};
</script>

<style lang="scss">
.video-list {
  padding-top: 20px;
  h1 {
    padding: 0 15px;
    svg {
      vertical-align: text-bottom;
    }
  }
}

@media screen and (min-width: 1025px) {
  .video-list {
    h1 {
      padding: 0;
    }
  }
}
</style>
